<script>
export default {
  name: "closeEyeIcon",
};
</script>

<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M14.3191 9.68076L9.68076 14.3191C9.08493 13.7233 8.71826 12.9074 8.71826 11.9999C8.71826 10.1849 10.1849 8.71826 11.9999 8.71826C12.9074 8.71826 13.7233 9.08493 14.3191 9.68076Z"
      stroke="#7A889B"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M17.335 6.28916C15.7308 5.07916 13.8975 4.41916 12 4.41916C8.76415 4.41916 5.74831 6.32583 3.64915 9.62583C2.82415 10.9183 2.82415 13.0908 3.64915 14.3833C4.37331 15.52 5.21665 16.5008 6.13331 17.2892"
      stroke="#7A889B"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M8.71826 18.9024C9.76326 19.3424 10.8724 19.5808 11.9999 19.5808C15.2358 19.5808 18.2516 17.6741 20.3508 14.3741C21.1758 13.0816 21.1758 10.9091 20.3508 9.6166C20.0483 9.13994 19.7183 8.69077 19.3791 8.2691"
      stroke="#7A889B"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M15.2174 12.6416C14.9791 13.9341 13.9249 14.9883 12.6324 15.2266"
      stroke="#7A889B"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M9.68087 14.3192L2.83337 21.1667"
      stroke="#7A889B"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M21.1667 2.83334L14.3192 9.68084"
      stroke="#7A889B"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<style scoped></style>
